import { Button } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';
import {
    NAVIGATION_OFFSET_CSS_VARIABLE,
    NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE,
} from '@telialt/utils/src/NavigationUtils/constants';

import { VisibilityVariant } from './model';

export const DisplayContainer = styled.div<{ $visibility: VisibilityVariant }>(
    ({ $visibility }) =>
        ($visibility === 'mobile' && purpurMedia('lg')({ display: 'none' })) ||
        ($visibility === 'always' && { display: 'block' }),
);

export const Overlay = styled.div`
    position: fixed;
    top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    transition-property: opacity, var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    background-color: ${getPurpurColor('overlayDefault')};

    @media (prefers-reduced-motion: no-preference) {
        transition-duration: ${getPurpurMotion('duration200')};
        transition-timing-function: ${getPurpurMotion('easingEaseInOut')};
        &[data-open='true'] {
            opacity: 1;
        }
        &[data-open='false'] {
            opacity: 0;
        }
    }
`;

type DrawerWrapperProps = {
    $isOpen: boolean;
    $isVisible: boolean;
};

const drawerWidth = '24.5rem';
export const DrawerWrapper = styled.section<DrawerWrapperProps>`
    position: fixed;
    top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    left: ${({ $isOpen }) => ($isOpen ? '0' : `-${drawerWidth}`)};
    right: 0;
    bottom: 0;
    transition:
        left 0.5s ease,
        var(${NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE});
    background-color: ${getPurpurColor('functionalWhite')};
    max-width: ${drawerWidth};
    min-width: 20rem;
    width: 100%;
    z-index: 2001;
    box-shadow: inset 0rem 0.25rem 0.5rem -0.25rem rgba(0, 0, 0, 0.1);
    display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
    flex-direction: column;
`;

export const DrawerHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${getPurpurSpacing('200')};
    border-bottom: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')};
`;

export const DrawerTitle = styled.div`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    color: ${getPurpurColor('textDefault')};
`;

export const XCloseButton = styled(Button)`
    padding: 0 !important;
`;

export const DrawerContent = styled.div`
    overflow-y: auto;
    flex: 1;
`;

export const DrawerFooter = styled.div`
    display: flex;
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray100')};
    flex-direction: column;
    align-items: stretch;
    gap: ${getPurpurSpacing('200')};
    padding: ${getPurpurSpacing('400')} ${getPurpurSpacing('300')};
`;
